import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { qtyStep } from "@/lib/constants";
import { SearchableSelect } from "@/components/ui/searchable-select";

export function BomStockFields({ form, set, isEdit, supplierOptions }) {
  const isRaw = form.item_type !== "manufactured";
  return (
    <>
      {!isEdit && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="space-y-1.5">
            <Label>Initial Stock ({form.unit})</Label>
            <Input type="number" min="0" step={qtyStep(form.unit)} value={form.stock_quantity}
              onChange={(e) => set("stock_quantity", e.target.value)} data-testid="bom-form-stock" />
          </div>
          <div />
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label>Reorder Level ({form.unit})</Label>
          <Input type="number" min="0" step={qtyStep(form.unit)} value={form.min_stock}
            onChange={(e) => set("min_stock", e.target.value)} data-testid="bom-form-min-stock" />
          <p className="text-[10px] text-slate-400">Low-stock alert triggers when on-hand drops below this. 0 = no alert.</p>
        </div>
        {isRaw ? (
          <div className="space-y-1.5">
            <Label>Preferred Supplier (Optional)</Label>
            <SearchableSelect
              value={form.supplier || "__none__"}
              onValueChange={(v) => set("supplier", v === "__none__" ? "" : v)}
              placeholder="— None —"
              searchPlaceholder="Search suppliers…"
              emptyText="No suppliers found."
              triggerClassName="h-9 text-sm bg-white"
              options={supplierOptions}
              testid="bom-form-supplier"
            />
            <p className="text-[10px] text-slate-400">Pre-selected when raising a PO for this material.</p>
          </div>
        ) : <div />}
      </div>
    </>
  );
}
